export default __webpack_public_path__ + "static/media/Btn_iPad.0adeb680.png";